<script lang="ts" setup>
import { navigateTo, useRoute } from "#app";
import { onMounted } from "vue";
import HomeContent from "~/components/home/HomeContent.vue";
import { STATES } from "~/constants/states";

// Change layout template
definePageMeta({
    layout: "no-container",
});

// Data
const route = useRoute();
const { state } = route.params;

// Simple (useSeoMeta) or useServerSeoMeta
useSeoMeta({
    title: "American Book Company - " + STATES[String(state).toUpperCase()],
});

onMounted(() => {
    if (!STATES[String(state).toUpperCase()]) {
        navigateTo("/home/ga");
    }
});
</script>

<template>
    <HomeContent :state="state as string" />
</template>
